import { render, staticRenderFns } from "./AdminRequestsTable.vue?vue&type=template&id=5ce4588a&scoped=true&"
import script from "./AdminRequestsTable.vue?vue&type=script&lang=js&"
export * from "./AdminRequestsTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminRequestsTable.vue?vue&type=style&index=0&id=5ce4588a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce4588a",
  null
  
)

export default component.exports